import React, { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/content/site";

const useFaqJsonLd = () => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "faq-jsonld";
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ.map(({ q, a }) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
    });
    document.head.appendChild(el);
    return () => el.remove();
  }, []);
};

export const Faq = () => {
  useFaqJsonLd();
  return (
    <section id="faq" className="mt-16 scroll-mt-24" data-testid="faq-section" aria-labelledby="faq-heading">
      <h2 id="faq-heading" className="font-display text-2xl font-medium text-[#F8F3E6]">Questions people ask first</h2>
      <Accordion type="single" collapsible className="mt-4">
        {FAQ.map((item, i) => (
          <AccordionItem key={item.q} value={`faq-${i}`} className="border-[#D9A441]/15">
            <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left text-[#F8F3E6] hover:no-underline">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-[#A3A5B8]">{item.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
